<template>
  <!-- 供需关系 -->
  <div class="outer-page">
    <x-table
      :no-data-text="CA('transport_check') ? '暂无数据' : '暂无数据查询权限'"
      :columns="table.columns"
      :data="table.data"
      :loading="table.loading"
      :config="config"
      @search="search"
      @page-change="pageChange"
      @page-size-change="pageSizeChange"
    ></x-table>

    <transport-Model
      v-model="DriverModel"
      :title="DriverTitle"
      :DefluteValue="DefluteValue"
      :defaultEdeit="defaultEdeit"
      @refrestList="refrestList"
    ></transport-Model>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import positionData from "./data";

import transportModel from "./transportModel";
export default {
  name: "",
  components: {
    transportModel,
  },
  data() {
    return {
      DriverModel: false,
      DriverTitle: "",
      DefluteValue: {},
      table: {
        columns: [
          {
            title:"订单开始时间",
            key:'startTime',
            width:200,
          },
          {
            title: "车牌号",
            width: 110,
            key: "carName",
          },
          {
            title: "司机姓名",
            width: 100,
            key: "driverName",
          },
          {
            title: "司机联系电话",
            width: 130,
            key: "driverPhone",
          },
          {
            title: "运输类型",
            width: 100,
            render: (h, { row }) => {
              return (
                <span>
                  {
                    row.transportType == 0
                      ? "供应订单"
                      : // row.transportType == "2" ?
                        "采购订单"
                    // : row.transportType == "3"
                    // ? "自填订单"
                    // : "其他"
                  }
                </span>
              );
            },
          },
          {
            title: "运输量(kg)",
            width: 80,
            ellipsis: true,
            tooltip: true,
            key: "weight",
          },
          {
            title: "收货人姓名",
            width: 120,
            ellipsis: true,
            tooltip: true,
            key: "receiveName",
          },
          {
            title: "收货人电话",
            width: 130,
            key: "receivePhone",
          },
          {
            title: "出发地址",
            width: 120,
            ellipsis: true,
            tooltip: true,
            key: "originAddress",
          },
          {
            title: "目的地",
            width: 120,
            ellipsis: true,
            tooltip: true,
            key: "transportAddress",
          },
          {
            title: "里程(km)",
            width: 120,
            key: "mileage",
          },
          {
            title: "运输描述",
            minWidth: 120,
            ellipsis: true,
            tooltip: true,
            key: "transportContent",
          },
          {
            title: "状态",
            minWidth: 80,
            render: (h, { row }) => {
              return (
                <span>{row.demandStatus == "1" ? "发布中" : "已处理"}</span>
              );
            },

          },
          {
            title: "操作",
            width: 150,
            fixed: 'right',

            render: (h, { row }) => {
              return (
                <div>
                  {row.transportStatus == 1 && (
                    <Poptip
                      confirm
                      transfer
                      title="确定运输开始吗?"
                      on-on-ok={() => this.transportStart(row.id)}
                    >
                      <a style="margin-right: 10px">运输开始</a>
                    </Poptip>
                  )}
                  {row.transportStatus == 2 && (
                    <Poptip
                      confirm
                      transfer
                      title="确定运输完成吗?"
                      on-on-ok={() => this.transportFinish(row.id)}
                    >
                      <a style="margin-right: 10px">运输完成</a>
                    </Poptip>
                  )}
                  {localStorage.userId == row.createUserId &&
                    this.CA("supply_finish") && (
                      <a
                        style="margin-right: 10px"
                        onClick={() =>
                          row.demandStatus == "1"
                            ? this.finishSupply(row.id)
                            : ""
                        }
                      >
                        {row.demandStatus == "1" ? "发布中" : "已处理"}
                      </a>
                    )}
                  {this.CA("transport_edit") && (
                    <a
                      style="margin-right: 10px"
                      onClick={() => this.edit(row)}
                    >
                      编辑
                    </a>
                  )}
                  {
                    <a
                      style="margin-right: 10px"
                      onClick={() => this.checkInfo(row)}
                    >
                      运输详情
                    </a>
                  }

                  {row.transportStatus == "1" && this.CA("transport_delete") && (
                    <Poptip
                      confirm
                      transfer
                      title="确定删除吗?"
                      on-on-ok={() => this.delete(row.id)}
                    >
                      <a>删除</a>
                    </Poptip>
                  )}
                </div>
              );
            },
          },
        ],
        data: [],
        loading: false,
      },
      config: {
        filter: {
          width: 200,
          filterBox: [
            {
              conditionName: "车牌号",
              component: "input",
              field: "carName",
              defaultValue: "",
            },
            // {
            //   conditionName: "司机",
            //   component: "input",
            //   field: "driverName",
            //   defaultValue: "",
            // },
            {
              conditionName: "司机电话",
              component: "input",
              field: "driverPhone",
              defaultValue: "",
            },
            {
              conditionName: "收货人",
              component: "input",
              field: "receiveName",
              defaultValue: "",
            },
            {
              conditionName: "收货电话",
              component: "input",
              field: "receivePhone",
              defaultValue: "",
            },
          ],
        },
        page: {
          pageNo: 1,
          pageSize: 10,
          total: 0,
        },
      },
      defaultEdeit: false,
      deptList: [],
      search_data: {},
    };
  },
  methods: {
    search(data) {
      this.search_data = data;
      this.config.page.pageNo = 1;
      this.getList();
    },
    pageChange(pageNo) {
      this.config.page.pageNo = pageNo;
      this.getList();
    },
    refrestList() {
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.config.page.pageSize = pageSize
      this.getList()
    },
    getList() {
      if (!this.CA("transport_check")) return;
      this.table.loading = true;
      this.$post(this.$api.TRANSPORT.LIST, {
        pageNo: this.config.page.pageNo,
        pageSize: this.config.page.pageSize,
        ...this.search_data,
      })
        .then((res) => {
          this.table.data = res.list;
          this.config.page.total = +res.total;
        })
        .finally(() => {
          this.table.loading = false;
        });
    },

    edit(row) {
      console.log(row)
      this.defaultEdeit = false;
      this.DriverModel = true;
      this.DriverTitle = "运输修改";
      this.DefluteValue = row;
    },
    checkInfo(row) {
      this.defaultEdeit = true;
      this.DefluteValue = row;
      this.DriverModel = true;
      this.DriverTitle = "运输详情";
    },
    transportStart(id) {
      this.$post(this.$api.TRANSPORT.START, {
        id,
      }).then(() => {
        this.$Message.success("运输开始");
        this.getList();
      });
    },
    transportFinish(id) {
      this.$post(this.$api.TRANSPORT.FINISH, {
        id,
      }).then(() => {
        this.$Message.success("运输完成");
        this.getList();
      });
    },
    //需求处理列表
    finishSupply(id) {
      this.$post(this.$api.SUPPLY_BIND.FINISH, { id: id })
        .then((res) => {
          this.$Message.success("处理成功");
          this.getList();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //删除
    delete(id) {
      this.$post(this.$api.TRANSPORT.DELETE, {
        id: id,
      }).then(() => {
        this.$Message.success("删除成功！");
        this.getList();
      });
    },
    //获取部门列表
    getDeptList() {
      this.$post(this.$api.company.BARNCHTREE)
        .then((res) => {
          this.deptList = res;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  mounted() {
    this.getDeptList();
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.outer-page {
  width: 100%;
  height: 100%;
}
</style>